import React from 'react';
import { Helmet } from 'react-helmet';

const config = require('../utils/constants/siteConfig');

const schemaOrgJSONLD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Everlywell',
  legalName: 'Everly Well, Inc.',
  url: 'https://www.everlywell.com/',
  logo:
    'https://www.everlywell.com/images/logos/2019-rebrand/everlywell-logo-e3288d32.svg',
  foundingDate: '2015',
  founders: [
    {
      '@type': 'Person',
      name: 'Julia Cheek',
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '823 Congress, Suite 1200',
    addressLocality: 'Austin',
    addressRegion: 'Texas',
    postalCode: '78701',
    addressCountry: 'United States',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    telephone: '+1 (855) 422-3855',
    email: 'contact@everlywell.com',
  },
  sameAs: [
    'https://www.facebook.com/everlywell/',
    'https://twitter.com/everly_well',
    'https://www.pinterest.com/everlywell/',
    'https://www.linkedin.com/company/everlywell',
  ],
};

interface Props {
  title?: string;
  description?: string;
  keywords?: string;
  url?: string;
}

export const Head = ({ title, description, keywords, url }: Props) => (
  <Helmet htmlAttributes={{ lang: 'en' }}>
    <script
      type="text/javascript"
      data-cfasync="false"
      src="https://try.abtasty.com/cc8c61e505f0a5d55545c679a7133d4b.js"
    ></script>
    {/* General tags */}
    <title>{title || config.title}</title>
    <meta name="description" content={description || config.siteDescription} />
    <meta name="keywords" content={keywords || config.keywords} />

    <link rel="canonical" href={url || config.siteUrl} />

    {/* Schema.org tags */}
    <script type="application/ld+json">
      {JSON.stringify(schemaOrgJSONLD)}
    </script>

    {/* OpenGraph tags */}
    <meta property="og:title" content={title || config.title} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={url || config.siteUrl} />
    <meta
      property="og:description"
      content={description || config.siteDescription}
    />

    {/* Twitter Card tags */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta
      name="twitter:creator"
      content={config.userTwitter ? config.userTwitter : ''}
    />
    <meta name="twitter:title" content={title || config.siteTitle} />
    <meta
      name="twitter:description"
      content={description || config.siteDescription}
    />
  </Helmet>
);
